// F15: analysis-level growth rates. Rents and costs are entered at each
// property's prices_as_of date and grown at these rates; there is no default,
// so the UI keeps what was typed and only sends the rates once both parse.

export interface GrowthRateInputs {
  euroInflationPct: string;
  rentGrowthPct: string;
}

export interface GrowthRates {
  euro_inflation_pct: number;
  rent_growth_pct: number;
}

export type ParsedGrowthRates =
  | { ok: true; rates: GrowthRates }
  | { ok: false; error: string };

function parseRate(label: string, raw: string): number | string {
  if (raw.trim() === '') return `Enter the ${label} rate (annual %, e.g. 2) before running.`;
  const n = Number(raw);
  if (!Number.isFinite(n)) return `The ${label} rate must be a number, got "${raw}".`;
  return n;
}

export function parseGrowthRates(inputs: GrowthRateInputs): ParsedGrowthRates {
  const inflation = parseRate('euro inflation', inputs.euroInflationPct);
  if (typeof inflation === 'string') return { ok: false, error: inflation };
  const rent = parseRate('rent growth', inputs.rentGrowthPct);
  if (typeof rent === 'string') return { ok: false, error: rent };
  return { ok: true, rates: { euro_inflation_pct: inflation, rent_growth_pct: rent } };
}

/** Names of properties with no prices_as_of date (the engine requires one). */
export function missingPricesAsOf(properties: { name?: string; prices_as_of?: string | null }[]): string[] {
  return properties
    .filter((p) => !p.prices_as_of)
    .map((p) => p.name || '(unnamed property)');
}
